require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-gdpr-are-you-front-end-compliant.json") })
        }
      }, "path---blog-gdpr-are-you-front-end-compliant");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-gdpr-are-you-front-end-compliant!./.cache/json/blog-gdpr-are-you-front-end-compliant.json
// module id = 446
// module chunks = 231608221292675